export enum E_PermissionUser {
  ADM = "Admin", // ADMIN
  CUST = "Customer", // CUSTOMER
  MAN = "Manager", // MANAGER
}
